module.exports = "https://cdn.realtymogul.com/static/media/OS_hero.ed4eabc9.jpg";